import { useAuthStore } from "../../authProvider";
import { ThemeProvider } from "@emotion/react";
import { lightCustomerTheme } from "../../configs/customer-theme";
import { ThemedLayoutV2 } from "@refinedev/mui";
import ClientHeader from "../header/client";
import { Header } from "../header";

export default function UserTheme({ children }: { children: React.ReactNode }) {
  const { user } = useAuthStore();

  const OffLayoutArea = () => (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="anonymous"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900"
        rel="stylesheet"
      />
    </>
  );

  if (!user) {
    return (
      <ThemedLayoutV2
        Sider={() => <></>}
        Header={() => <></>}
        OffLayoutArea={OffLayoutArea}
      >
        <ThemeProvider theme={lightCustomerTheme}>{children}</ThemeProvider>
      </ThemedLayoutV2>
    );
  }

  if (user?.isClientRelated) {
    return (
      <ThemedLayoutV2
        Sider={() => <></>}
        Header={ClientHeader}
        OffLayoutArea={OffLayoutArea}
      >
        <ThemeProvider theme={lightCustomerTheme}>{children}</ThemeProvider>
      </ThemedLayoutV2>
    );
  }

  return (
    <ThemedLayoutV2
      Sider={() => <></>}
      Header={Header}
      OffLayoutArea={OffLayoutArea}
    >
      {children}
    </ThemedLayoutV2>
  );
}
